import { Component, OnInit } from "@angular/core";
import { GlobalVariablesService } from "../../Services/globalVariables/global-variables.service";
import { UserManager } from "../../Services/UserManager/user-manager";
import { Profile } from "../../Models/profile.interface";
import { studentQuestion } from "../../Models/studentQuestion.interface";
import { ScrollService } from "../../Services/ScrollManager/scroll.service";
import {
  trigger,
  state,
  transition,
  style,
  animate,
} from "@angular/animations";
import _ from "lodash";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.css"],
  animations: [
    trigger("trigger", [
      state("void", style({ opacity: 0 })),
      state("show", style({ opacity: 1 })),
      transition("void => *", [animate("400ms ease-in-out")]),
      transition("* => void", [animate("400ms ease-in-out")]),
    ]),
  ],
})
export class ContactUsComponent implements OnInit {
  config;
  name: string;
  email: string;
  bibleQuestion: boolean;
  supportQuestion: boolean;
  prayerRequest: boolean;
  other: boolean;
  message: string;
  verificationMessage: boolean = false;
  errorMessage: string;
  currentState = "void";
  constructor(
    private gv: GlobalVariablesService,
    private um: UserManager,
    private scroll: ScrollService,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {
    this.scroll.scrollToElement("#logo");
    this.currentState = "show";
  }

  submitMessage() {
    this.gv.print(this.name);
    this.gv.print(this.email);
    this.gv.print(this.bibleQuestion);
    this.gv.print(this.message);
    if (!this.name) {
      this.displayErrorMessage(this.config.contactUsErrorNoName);
      // this.displayErrorMessage("No Name Provided")
      return;
    }

    if (!this.email) {
      this.displayErrorMessage(this.config.contactUsErrorNoEmail);
      // this.displayErrorMessage("No Email Provided")
      return;
    }

    if (!this.message) {
      this.displayErrorMessage(this.config.contactUsErrorNoMessage);
      // this.displayErrorMessage("No Message Provided")
      return;
    }
    var question = {} as studentQuestion;
    var profile = this.um.getUserProfileSnapshot() as Profile;

    question.name = this.name;
    question.email = this.email;
    question.message = this.message;
    question.bibleQuestion = this.bibleQuestion ? this.bibleQuestion : false;
    question.supportQuestion = this.supportQuestion
      ? this.supportQuestion
      : false;
    question.prayerRequest = this.prayerRequest ? this.prayerRequest : false;
    question.otherTypeQuestion = this.other ? this.other : false;
    question.unread = true;
    question.date = new Date().getTime();
    question.sortDate = 0 - new Date().getTime();
    question.anonymous = profile.anonymous || false;

    if (profile) {
      question.profileEmail = profile.email || "";
      question.profileName =
        _.get(profile, "firstname", "") + " " + _.get(profile, "lastname", "");
      question.uid === profile.uid || "";
    }
    this.sendMessage(question);
  }

  sendMessage(message: studentQuestion) {
    // this.gv.print('sending message')
    this.um.sendMessage(message).then((result) => {
      if (result) {
        // this.gv.print("Message Sent")
        this.displaySuccessMessage();
        this.message = "";
        this.name = "";
        this.email = "";
        this.bibleQuestion = undefined;
        this.supportQuestion = undefined;
        this.other = undefined;
      } else {
        this.displayErrorMessage(this.config.contactUsErrorUnknown);
      }
    });
  }

  displaySuccessMessage() {
    this.verificationMessage = true;
  }
  hideSuccessMessage() {
    this.verificationMessage = false;
  }

  displayErrorMessage(message: string) {
    this.errorMessage = message;
  }
  hideErrorMessage() {
    this.errorMessage = null;
  }
}
